"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { button, text } from './styles.js';
import { renderComponentOrElement } from '../utils/helpers/component.js';
import { Box } from '../Box/Box.web.js';
import { handleButtonUnfocusMouseEvent } from './utils.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { ThemeProvider } from 'styled-components';
import { Loader } from '../Loader/Loader.web.js';

var _excluded = ["color", "disabled", "invert", "status", "size", "children", "leftIcon", "rightIcon", "onMouseUp", "onMouseOut", "autoResize", "tag", "variant", "loading", "transparent"];
/**
 * Buttons make common actions visible and easy to perform. Some examples
 * include Submit, Save, Log in.
 */
var ButtonComponent = function ButtonComponent(props, ref) {
  var colorProp = props.color,
    _props$disabled = props.disabled,
    disabled = _props$disabled === undefined ? false : _props$disabled,
    _props$invert = props.invert,
    invert = _props$invert === undefined ? false : _props$invert,
    _props$status = props.status,
    status = _props$status === undefined ? 'primary' : _props$status,
    _props$size = props.size,
    size = _props$size === undefined ? 'm' : _props$size,
    children = props.children,
    leftIcon = props.leftIcon,
    rightIcon = props.rightIcon,
    onMouseUp = props.onMouseUp,
    onMouseOut = props.onMouseOut,
    _props$autoResize = props.autoResize,
    autoResize = _props$autoResize === undefined ? false : _props$autoResize,
    tag = props.tag,
    variantProp = props.variant,
    _props$loading = props.loading,
    loadingProp = _props$loading === undefined ? false : _props$loading,
    _props$transparent = props.transparent,
    transparent = _props$transparent === undefined ? false : _props$transparent,
    rest = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var variant = variantProp || theme.variant;
  var buttonTheme = theme.button.web;
  var handleMouseUp = React.useMemo(function () {
    return handleButtonUnfocusMouseEvent(onMouseUp);
  }, [onMouseUp]);
  var handleMouseOut = React.useMemo(function () {
    return handleButtonUnfocusMouseEvent(onMouseOut);
  }, [onMouseOut]);
  var showLeftLoader = loadingProp;
  var color = typeof colorProp === 'string' ? colorProp : transparent ? theme.colors.primary : buttonTheme.color;
  var setDisabledAttributes = disabled || loadingProp;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(button, _extends({
    "data-testid": "elemental-Button",
    type: "button",
    as: tag,
    $withLeftIcon: !!leftIcon || showLeftLoader,
    $withRightIcon: !!rightIcon,
    onMouseUp: handleMouseUp,
    onMouseOut: handleMouseOut,
    $color: color,
    disabled: setDisabledAttributes,
    "aria-disabled": setDisabledAttributes ? true : undefined,
    $invert: invert,
    $transparent: transparent,
    $loading: loadingProp,
    $status: status,
    $size: size,
    $autoResize: autoResize,
    $variant: variant,
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    height: "100%"
  }, showLeftLoader ? /*#__PURE__*/React.createElement(Loader, {
    size: 20,
    color: status === 'campaign' ? theme.button.web.campaign.textColor : theme.colors.text
  }) : leftIcon && renderComponentOrElement(leftIcon, {
    size: 24,
    'aria-hidden': true
  }), children && /*#__PURE__*/React.createElement(text, null, children), rightIcon && renderComponentOrElement(rightIcon, {
    size: 24,
    'aria-hidden': true
  }))));
};
var Button = /*#__PURE__*/React.forwardRef(ButtonComponent);

export { Button };
